// avec createMuiTheme on peut crée notre propre theme en utilisant les components de material UI
import { createTheme } from "@mui/material/styles"
// importer la palette des couleurs de material,
// on peut dériver les couleurs de notre charte à partir de cette palette
import { grey, blue, green, red, yellow, indigo } from "@mui/material/colors"

/**
 * Crée le theme par defaut de l'application
 */
const theme = createTheme({
    palette: {
        primary: {
            main: "#200943",
        },
        secondary: {
            main: "#200943",
            dark: indigo[500],
            light: grey[50],
        },
        error: {
            main: red[500],
        },
        warning: {
            main: yellow[500],
        },
        info: {
            main: blue[500],
        },
        success: {
            main: green[500],
        },
    },
    // y a d'autres modifications à faire au niveau de théme
})
export default theme
